var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("span", { staticClass: "show-acc" }, [
    _c("span", { staticClass: "name" }, [_vm._v(_vm._s(_vm.acc.name))]),
    _vm._v(" "),
    _vm.acc.type === "bank"
      ? _c(
          "span",
          { staticClass: "details" },
          [
            _vm.acc.is
              ? [
                  _vm._v("БИК: " + _vm._s(_vm.acc.bik)),
                  _c("br"),
                  _vm._v("Счет: " + _vm._s(_vm.acc.anumber)),
                ]
              : [_vm._v("Банковский счет не указан")],
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }